module.exports = __webpack_public_path__ + "assets/icon-animalType-pony.29374cc4.svg";